{
  "loader": {
    "retry": {
      "message": "Loading failed..."
    }
  },
  "notifications": {
    "invalidStore": "Invalid store. Switched to your default store.",
    "invalidAisles": "Invalid aisles. Switched to default filter value.",
    "invalidDepartments": "Invalid departments. Switched to default filter value.",
    "invalidTimeRange": "Invalid time range. Switched to default.",
    "storeAccessChanged": "Store access changed. Please log in again."
  },
  "status": {
    "active": "active",
    "inactive": "inactive",
    "deleted": "deleted"
  }
}
